export default "__VITE_ASSET__OM46Vf4t__"